import { createContext, ReactNode, useMemo } from 'react';

// project imports
import config from '@/theme/config';
import { useLocalStorage } from '@/theme/useLocalStorage';

// types
import { ConfigContextValue, ConfigStates } from '@/theme/types/config';

export type Props = {
	children: ReactNode;
};

// ==============================|| CONFIG CONTEXT ||============================== //

export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

// ==============================|| CONFIG PROVIDER ||============================== //

export function ConfigProvider({ children }: Props) {
	const { state, setState, setField, resetState } = useLocalStorage<ConfigStates>(
		'cityzen-config',
		config
	);

	// Config-ul persistat se așază PESTE default-urile din cod (câmpurile noi primesc default),
	// iar `fontFamily` vine mereu din cod — nu are UI de configurare, deci o valoare veche din
	// localStorage ar suprascrie pentru totdeauna schimbările de default (fontul n-ar mai fi
	// aliniat cu template-ul indiferent de ce modificăm în config.ts).
	const effectiveState = useMemo<ConfigStates>(
		() => ({ ...config, ...state, fontFamily: config.fontFamily }),
		[state]
	);

	const memoizedValue = useMemo(
		() => ({ state: effectiveState, setState, setField, resetState }),
		[effectiveState, setField, setState, resetState]
	);

	return (
		<ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>
	);
}
